export default __webpack_public_path__ + "81c8b7408fe11194236a827fe0156c7c.svg";